import { render, staticRenderFns } from "./BodyCell.vue?vue&type=template&id=4ff217a4&"
import script from "./BodyCell.vue?vue&type=script&lang=js&"
export * from "./BodyCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports